import { render, staticRenderFns } from "./resultList.vue?vue&type=template&id=f9486878&scoped=true&"
import script from "./resultList.vue?vue&type=script&lang=js&"
export * from "./resultList.vue?vue&type=script&lang=js&"
import style0 from "./resultList.vue?vue&type=style&index=0&id=f9486878&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9486878",
  null
  
)

export default component.exports